define(["require", "exports", "./context", "./analytics", "./dialogs/login"], function (require, exports, context_1, analytics_1, login_1) {
    "use strict";
    exports.__esModule = true;
    function default_1(evt) {
        analytics_1["default"]('cart', 'startCheckout');
        window.fbq('tarck', 'InitiateCheckout');
        if (!context_1["default"].isUserLoggedIn()) {
            login_1["default"](true);
            return false;
        }
        else {
            return true;
        }
    }
    exports["default"] = default_1;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/startCheckout.js
// module id = 75
// module chunks = 0